export default __webpack_public_path__ + "static/media/marketing-real-estate-freezer.5e13229a.svg";